(function() {

  'use strict';

  function MercadoLivre($q, MercadoLivreResource) {

    var MercadoLivre = {};

    MercadoLivre.authorize = function(callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      MercadoLivreResource.authorize()
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    MercadoLivre.getEmail = function(callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      MercadoLivreResource.getEmail()
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    MercadoLivre.logoutML = function(callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      MercadoLivreResource.logoutML()
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    return MercadoLivre;

  }

  angular
    .module('mandaeApp')
    .factory('MercadoLivre', MercadoLivre);

})();
